import { red } from "@material-ui/core/colors";
import { createTheme } from "@material-ui/core/styles";

// A custom theme for this app
const theme = createTheme({
    typography: {
        fontFamily: ["AvenirLTPro", "sans-serif"].join(","),
    },
    overrides: {
        MuiButton: {
            root: {
                textTransform: "capitalize",
                minWidth: 100,
                marginLeft: 8,
                marginRight: 8,
            },
            contained: {
                boxShadow: "unset",
            },
        },
        MuiAccordionSummary: {
            root: {
                minHeight: 32,
            },
            content: {
                margin: 0,
            },
        },
        MuiInputBase: {
            root: {
                "&$disabled": {
                    opacity: 1,
                },
            },
        },
        MuiCardHeader: {
            root: {
                padding: 8,
            },
            action: {
                marginTop: 0,
                marginRight: 0,
            },
        },
        MuiCardContent: {
            root: {
                padding: 8,
            },
        },
        MuiOutlinedInput: {
            inputMarginDense: {
                paddingTop: 8.5,
            },
        },
        MuiListItemIcon: {
            root: {
                minWidth: "unset",
                marginRight: 8,
            },
        },
        MuiTimelineItem: {
            root: {
                minHeight: 100,
            },
        },
    },
    palette: {
        primary: {
            main: "#7900F8",
        },
        secondary: {
            main: "#E38301",
            contrastText: "white",
        },
        error: {
            main: red.A400,
        },
        background: {
            default: "rgba(0, 0, 0, 0.05)",
        },
    },
});

export default theme;
